import { useCallback, useRef, useState } from 'react';

export default function useInput<
  T extends HTMLInputElement | HTMLTextAreaElement,
>(initialValue = '') {
  const ref = useRef<T>(null);
  const [value, setValue] = useState(initialValue);
  const onChange = useCallback((e) => setValue(e.target.value), []);
  const clear = useCallback(() => setValue(''), []);
  const focus = useCallback(() => {
    if (ref.current) ref.current.focus();
  }, [ref]);
  const select = useCallback(() => {
    if (ref.current) {
      ref.current.focus();
      ref.current.select();
    }
  }, [ref]);

  return {
    value,
    setValue,
    onChange,
    clear,
    focus,
    select,
    ref,
    bind: {
      onChange,
      value,
      ref,
    },
  };
}
